import { Component, createRef } from "react";
import { NSALayout, NSALayoutCustomProps } from "namirasoft-account-react";

export class ContainerRegistryLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<NSALayoutCustomProps<RowType, RowTypeInput>>
{
    NSALayout_Ref = createRef<NSALayout<RowType, RowTypeInput>>();

    override render()
    {
        return (
            <NSALayout
                {...this.props}
                ref={this.NSALayout_Ref}
            >
                {this.props.children}
            </NSALayout>
        )
    }
}